<template>
    <div class="budget">
        <div class="budget-header"><span>YOUR BUDGET</span></div>
        <div class="range-slider position-relative">
            <VueSlider
                class="slider-select"
                v-model="values"
                :min="50"
                :max="5000"
                step="10"
            />
            <div class="sums text-center">
                <span>{{ average }}</span>
            </div>
            <div class="position-absolute" style="bottom: 13px">
                <BarChart
                    :style="{
                        paddingRight: rightPosition + 'px',
                        paddingLeft: 25 + leftPosition + 'px'
                    }"
                    :width="515"
                    :height="40"
                    :selectedDataBar="chartDataBar"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlider from 'vue-slider-component'
    import BarChart from '../chart-bar/BarChart.vue'
    import 'vue-slider-component/theme/default.css'
    import axios from 'axios'

    export default {
        name: 'BudgetInfo',
        components: {
            VueSlider,
            BarChart
        },
        props: {
            budgetData: {
                type: Array
            }
        },
        data: () => ({
            values: [],
            selectedDataBar: '',
            transformedEventsForBudget: [],
            events: []
        }),
        methods: {
            getMinBudget() {
                let minValue = Math.min(...this.values)
                this.$emit('update:minBudget', minValue)
            },
            getMaxBudget() {
                let maxValue = Math.max(...this.values)
                this.$emit('update:maxBudget', maxValue)
            },
            getAverageBudget() {
                this.$emit('update:averageBudget', this.average)
            },
            getEventForBudget() {
                this.transformedEventsForBudget = this.events.map((event) => event.budget)
            }
        },
        computed: {
            chartDataBar() {
                return {
                    labels: this.changeChartData,
                    datasets: [
                        {
                            data: this.changeChartData,
                            backgroundColor: ['#D7EB5A'],
                            borderWidth: 1
                        }
                    ]
                }
            },
            rightPosition() {
                return (5000 - Math.max(...this.transformedEventsForBudget)) / 10
            },
            leftPosition() {
                return Math.min(...this.transformedEventsForBudget) - this.values[0]
            },
            average() {
                return Math.ceil((this.values[0] + this.values[1]) / 2)
            },
            changeChartData() {
                let min = this.values[0]
                let max = this.values[1]
                let chartDataFilter = this.transformedEventsForBudget
                return chartDataFilter.filter((item) => item >= min && item <= max)
            },
            min() {
                return this.values[0]
            },
            max() {
                return this.values[1]
            }
        },

        watch: {
            values: function () {
                this.getMinBudget()
                this.getMaxBudget()
                this.getAverageBudget()
            }
        },
        async created() {
            const response = await axios.get('/events/new-and-proceed-list-guest')
            this.events = response.data.bids
            this.getEventForBudget()
            let maxValue = Math.max(...this.transformedEventsForBudget)
            this.values = [50, maxValue]
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .budget {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .budget-header {
        margin-top: 42px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #ffffff;
    }
</style>

<style>
    .range-slider .slider-select .vue-slider-process {
        background-color: yellow;
        background: #d7eb5a;
        border-radius: 10px;
        cursor: pointer;
    }
    .range-slider .slider-select .vue-slider-piecewise {
        background-color: yellow;
    }
    .range-slider .slider-select.vue-slider-wrapper {
        border-color: yellow;
    }
    .range-slider .vue-slider-dot-handle {
        background: #49306b;
        width: 30px;
        height: 30px;
        position: absolute;
        top: -8px;
    }
    .range-slider .vue-slider-rail {
        background-color: #ccc;
        border-radius: 15px;
        height: 7px;
    }
    .range-slider .vue-slider-dot-tooltip-inner {
        font-family: Instrument Sans;
        display: block;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 150%;
        position: relative;
        left: 8px;
        color: #d7eb5a;
        background: none;
        opacity: 0.6;
    }
    .range-slider .vue-slider-dot-tooltip-inner-top::after {
        display: none;
    }
    .range-slider .range-slider {
        width: 515px;
        margin-top: 82px;
        height: 20px;
        position: relative;
    }
    .range-slider .chartjs-render-monitor .chartjs-size-monitor {
        opacity: 0;
        overflow: hidden !important;
    }
    .range-slider .bar-slider {
        width: 70%;
        position: relative;
        height: 40px;
        top: -100px;
    }
</style>
